import React from "react";
import {
  ArticleOutlined,
  AttachFile,
  DateRangeRounded,
  InfoOutlined,
  LocalShippingOutlined,
  MoreHorizOutlined,
  PictureAsPdfOutlined,
} from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";
import FileIcon from "components/Shared/FileIcon";

import { useShipmentFulfillmentDocumentDetailContext } from "contexts/ShipmentFulfillmentDocumentDetailContext";

import { localizeDateShort } from "utils/dateFormats";
import OpenInNewTab from "components/Shared/OpenInNewTab";

const ShipmentFulfillmentDocumentBasicDetail = () => {
  const statusColorMap = {
    valid: "primary",
    expired: "error",
    pending: "secondary",
  };

  const { shipmentFDDetail, loadingShipmentFD } =
    useShipmentFulfillmentDocumentDetailContext();

  return !loadingShipmentFD ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <ArticleOutlined color="primary" />}
            title="Document ID"
            subtitle={shipmentFDDetail?.documentId}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <PictureAsPdfOutlined color="primary" />}
            title="Document Type"
            subtitle={shipmentFDDetail?.type}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment"
            subtitle={
              shipmentFDDetail?.shipmentId &&
              typeof shipmentFDDetail.shipmentId === "object" ? (
                <OpenInNewTab
                  label={shipmentFDDetail.shipmentId.shipmentId}
                  link={`/app/crm/shipment/${shipmentFDDetail.shipmentId._id}/detail`}
                />
              ) : (
                shipmentFDDetail?.shipmentId || "N/A"
              )
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DateRangeRounded color="primary" />}
            title="Issue Date"
            subtitle={localizeDateShort(shipmentFDDetail?.issueDate)}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DateRangeRounded color="primary" />}
            title="Expiration Date"
            subtitle={localizeDateShort(shipmentFDDetail?.expirationDate)}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <MoreHorizOutlined color="primary" />}
            title="Status"
            subtitle={
              <Typography color={statusColorMap[shipmentFDDetail?.status]}>
                {shipmentFDDetail?.status}
              </Typography>
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={shipmentFDDetail?.isActive} />
          </InformationTile>
        </Grid>
        <Grid item md={12}>
          <InformationTile
            icon={() => <AttachFile color="primary" />}
            title="Attachments"
          >
            {shipmentFDDetail?.attachments && (
              <div className="flex gap-4">
                {shipmentFDDetail?.attachments?.map((attachment) => (
                  <a
                    key={attachment?._id}
                    href={attachment?.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "var(--primary)" }}
                  >
                    <FileIcon
                      fileName={attachment?.name}
                      fileUrl={attachment?.url}
                    />
                  </a>
                ))}
              </div>
            )}
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default ShipmentFulfillmentDocumentBasicDetail;
